import React from "react";
import { TEXTS } from "../../constants";
import logoSvg from "../../assets/dark-logo.svg";
import {
  SignPageWrapper,
  PageContent,
  DecorativeShape,
  ExpiredContainer,
  ExpiredCard,
  ExpiredIcon,
  ExpiredInfoBox,
  ExpiredNote,
  Logo,
} from "./SignPage.styles";

function ExpiredScreen({ clientName }) {
  return (
    <SignPageWrapper>
      <DecorativeShape className="shape1" />
      <DecorativeShape className="shape2" />
      <DecorativeShape className="shape3" />
      <DecorativeShape className="shape4" />
      <PageContent>
        <ExpiredContainer>
          <ExpiredCard>
            {/* DevCraft Logo */}
            <Logo
              src={logoSvg}
              alt="DevCraft"
              style={{ marginBottom: "20px" }}
            />

            {/* Expired Icon */}
            <ExpiredIcon>⏰</ExpiredIcon>

            <h1
              style={{
                color: "#B06000",
                marginBottom: "8px",
                fontSize: "1.375rem",
                fontWeight: 500,
              }}
            >
              {TEXTS.EXPIRED.TITLE}
            </h1>

            <p
              style={{
                color: "#5F6368",
                marginBottom: "20px",
                fontSize: "0.9375rem",
                lineHeight: 1.5,
              }}
            >
              {clientName && `${TEXTS.VERIFICATION.GREETING} ${clientName}, `}
              {TEXTS.EXPIRED.MESSAGE}
            </p>

            <ExpiredInfoBox>
              <p>
                <strong>{TEXTS.EXPIRED.WHAT_TO_DO.TITLE}</strong>
              </p>
              <ul>
                <li>{TEXTS.EXPIRED.WHAT_TO_DO.CONTACT_PROVIDER}</li>
                <li>{TEXTS.EXPIRED.WHAT_TO_DO.CHECK_MESSAGES}</li>
              </ul>
            </ExpiredInfoBox>

            <ExpiredNote>{TEXTS.EXPIRED.NOTE}</ExpiredNote>
          </ExpiredCard>
        </ExpiredContainer>
      </PageContent>
    </SignPageWrapper>
  );
}

export default ExpiredScreen;
